import React, { useState } from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { SIA_NAVY } from '../../../constants/siaTheme'

const CatalogIndex = ({ slug, title, entries, canEdit }) => {
    const { flash } = usePage().props
    const [search, setSearch] = useState('')

    const rows = (entries || []).filter((row) => {
        if (!search.trim()) return true
        const q = search.trim().toLowerCase()
        return (
            String(row.name || '').toLowerCase().includes(q) ||
            String(row.code || '').toLowerCase().includes(q)
        )
    })

    const showCode = slug === 'status' || slug === 'metodo-pago'
    const colSpan = (showCode ? 4 : 3) + (canEdit ? 1 : 0)

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath={`admin/cobranza/catalogos/${slug}`} />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Cobranza — {title}
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-header border-0 pt-6 flex-wrap gap-3">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Catálogo</span>
                        <span className="text-muted mt-1 fw-semibold fs-7">{title}</span>
                    </h3>
                    <div className="card-toolbar d-flex flex-wrap align-items-center gap-3">
                        <Form
                            onSubmit={(e) => e.preventDefault()}
                            className="d-flex flex-wrap align-items-center gap-2"
                        >
                            <Form.Control
                                type="search"
                                size="sm"
                                className="form-control-solid"
                                placeholder="Nombre o código…"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                style={{ minWidth: '180px' }}
                            />
                            <Button type="button" size="sm" variant="light" onClick={() => setSearch('')}>
                                Limpiar
                            </Button>
                        </Form>
                        {canEdit && (
                            <Link href={route('cobranza.catalogs.create', slug)} className="btn btn-sm btn-primary">
                                <i className="bi bi-plus-lg me-1" />
                                Nuevo
                            </Link>
                        )}
                    </div>
                </div>

                <div className="card-body pt-0">
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="min-w-200px ps-4 rounded-start">Nombre</th>
                                    {showCode && <th className="min-w-120px">Código</th>}
                                    <th className="min-w-80px">Orden</th>
                                    <th className="min-w-80px">Activo</th>
                                    {canEdit && (
                                        <th className="min-w-100px text-end pe-4 rounded-end">Acciones</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody className="fs-7">
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={colSpan} className="text-center text-muted py-10">
                                            Sin registros.
                                        </td>
                                    </tr>
                                ) : (
                                    rows.map((row) => (
                                        <tr key={row.id}>
                                            <td className="ps-4 fw-semibold text-gray-800">{row.name}</td>
                                            {showCode && <td className="text-gray-700">{row.code || '—'}</td>}
                                            <td className="text-gray-700">{row.sort_order}</td>
                                            <td>
                                                {row.is_active ? (
                                                    <span className="badge badge-light-success">Sí</span>
                                                ) : (
                                                    <span className="badge badge-light-secondary">No</span>
                                                )}
                                            </td>
                                            {canEdit && (
                                                <td className="text-end pe-4">
                                                    <Link
                                                        href={route('cobranza.catalogs.edit', [slug, row.id])}
                                                        className="btn btn-sm btn-icon btn-light-primary"
                                                        title="Editar"
                                                    >
                                                        <i className="bi bi-pencil" />
                                                    </Link>
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Row>
    )
}

CatalogIndex.layout = (page) => <Layout title={`Cobranza — ${page.props.title}`}>{page}</Layout>

export default CatalogIndex
